import type { Directive } from 'vue'

type OnLoadedValue = (() => void) | null | undefined

const runIfFunction = (value: OnLoadedValue) => {
  if (typeof value === 'function') {
    // Wait one frame to ensure DOM/content is rendered before callback runs.
    requestAnimationFrame(() => value())
  }
}

const onLoadedDirective: Directive<HTMLElement, OnLoadedValue> = {
  mounted(el, binding) {
    runIfFunction(binding.value)
    el.dispatchEvent(new CustomEvent('loaded'))
  },
  updated(el, binding) {
    runIfFunction(binding.value)
    el.dispatchEvent(new CustomEvent('loaded'))
  }
}

export default onLoadedDirective

